export const BUSINESS = {
  name: 'Hardwire Electrical LLC',
  phone: '352-615-3878',
  telephone: 'tel:3526153878',
  email: 'hardwireelectricalllc@gmail.com',
  office: 'Premier Office Center',
  street: '1910 SW 18th Ct, Bldg 100, Ste 408',
  locality: 'Ocala, FL 34471',
  licenseHolder: 'Larry Honor',
  license: 'ES 12002198',
  countyCertification: '24483',
};
export const PUBLIC_NAV = [
  ['/', 'Home'], ['/services', 'Services'], ['/residential', 'Residential'], ['/commercial', 'Commercial'], ['/builders', 'Builders'], ['/projects', 'Projects'], ['/about', 'About'],
  ['/resources', 'Resources'], ['/marketplace', 'Marketplace'], ['/contact', 'Contact'],
];
export const COMPANY_VIDEOS = [
  { id: 'on-the-job', src: '/videos/v2.mp4', poster: '/videos/v2.jpg', title: 'On the job' },
  { id: 'installation', src: '/videos/v3.mp4', poster: '/videos/v3.jpg', title: 'Installation footage' },
  { id: 'company', src: '/videos/v1.mp4', poster: '/videos/v1.jpg', title: 'A closer look at Hardwire' },
];
